import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const LeadsServices = {
    fetchLeadsList : async (data) =>{
        console.log("data",data);
                const queryParams = new URLSearchParams();
        
                // Basic pagination and sorting parameters
                queryParams.append('page', data.page + 1);
                queryParams.append('limit', data.limit);
        
                // Search parameters
                queryParams.append('searchKey', data.filters.searchKey || '');
                
        
                // Sorting parameters
                if (data.filters.sortKey) {
                    queryParams.append('sortKey', data.filters.sortKey);            
                    queryParams.append('sortDirection', data.filters.sortDirection || 'desc');
                }
                
                // Active or not filters
                queryParams.append('isActive', data.filters?.isActive || '');
        
                // Additional multi-column filters
                if (data.filters.filterOptions) {
                    data.filters.filterOptions.forEach((filter, index) => {
                        if (filter.fieldName && filter.value) {
                            queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                            queryParams.append(`filters[${index}][operator]`, filter.operator);
                            queryParams.append(`filters[${index}][value]`, filter.value);
                            
                            if (index !== 0) {
                                queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                            }
                            
                            if (filter.operator === 'between') {
                                queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                            }
                        }
                    });
                }
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/lyns-leads/list?${queryParams.toString()}`, {}, Helpers.token());
    },
}